"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOAST_CONTENT_PROPTYPES = exports.DURATIONS = exports.POSITIONS = exports.buttonOverridesFromTheme = void 0;

var _componentLayerManager = require("@doordash/component-layer-manager");

var _designLanguage = require("@doordash/design-language");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var buttonOverridesFromTheme = function buttonOverridesFromTheme(theme) {
  return {
    Colors: {
      ButtonFlatPrimaryForeground: theme.Colors.ToastInformationalAction,
      ButtonFlatPrimaryForegroundDisabled: theme.Colors.ToastInformationalActionDisabled,
      ButtonFlatPrimaryForegroundHovered: theme.Colors.ToastInformationalActionHovered,
      ButtonFlatPrimaryForegroundPressed: theme.Colors.ToastInformationalActionPressed
    },
    Typography: {
      TextStyles: {
        ToastAction: theme.Typography.TextStyles.ToastAction
      }
    }
  };
};

exports.buttonOverridesFromTheme = buttonOverridesFromTheme;
var POSITIONS = {
  TopStart: _componentLayerManager.AnchoredLayer.Positions.TopLeft,
  TopCenter: _componentLayerManager.AnchoredLayer.Positions.TopCenter,
  TopEnd: _componentLayerManager.AnchoredLayer.Positions.TopRight,
  BottomStart: _componentLayerManager.AnchoredLayer.Positions.BottomLeft,
  BottomCenter: _componentLayerManager.AnchoredLayer.Positions.BottomCenter,
  BottomEnd: _componentLayerManager.AnchoredLayer.Positions.BottomRight
};
exports.POSITIONS = POSITIONS;
var DURATIONS = {
  Short: 4000,
  Medium: 6000,
  Long: 10000
};
exports.DURATIONS = DURATIONS;
var TOAST_CONTENT_PROPTYPES = {
  icon: _propTypes["default"].oneOf(Object.values(_designLanguage.Icon.Types)),
  position: _propTypes["default"].oneOf(Object.values(POSITIONS)),
  text: _propTypes["default"].string.isRequired,
  action: _propTypes["default"].shape({
    text: _propTypes["default"].string.isRequired,
    onClick: _propTypes["default"].func.isRequired
  }),
  insetFromEdge: _propTypes["default"].oneOf(Object.values(_designLanguage.Inset.Sizes)),
  onHide: _propTypes["default"].func
};
exports.TOAST_CONTENT_PROPTYPES = TOAST_CONTENT_PROPTYPES;